/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Library } from '../../Library';
import { AaiServer } from '../../asyncapi/models/AaiServer';
import { Aai20Document } from '../../asyncapi/v2/models/Aai20Document';
import { AbstractCommand } from '../AbstractCommand';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { NodeCompat } from '../../compat/NodeCompat';
import { Constants } from '../../core/Constants';
import { Document } from '../../core/models/Document';
import { MarshallCompat } from '../../compat/MarshallCompat';
import { Node } from '../../core/models/Node';

/**
 * A command used to delete a single server from an aaidocument.
 * @author c.desc2@gmail.com
 * @extends AbstractCommand
 * @class
 */
export class DeleteServerCommand_Aai20 extends AbstractCommand {
    public _serverName : string;

    public _oldServer : any;

    public constructor(server? : any) {
        if(((server != null && server instanceof <any>AaiServer) || server === null)) {
            let __args = arguments;
            super();
            if(this._serverName===undefined) this._serverName = null;
            if(this._oldServer===undefined) this._oldServer = null;
            if(this._serverName===undefined) this._serverName = null;
            if(this._oldServer===undefined) this._oldServer = null;
            (() => {
                this._serverName = server.getName();
            })();
        } else if(server === undefined) {
            let __args = arguments;
            super();
            if(this._serverName===undefined) this._serverName = null;
            if(this._oldServer===undefined) this._oldServer = null;
            if(this._serverName===undefined) this._serverName = null;
            if(this._oldServer===undefined) this._oldServer = null;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[DeleteServerCommand_Aai20] Executing.");
        this._oldServer = null;
        let parent : Aai20Document = <Aai20Document>document;
        if(this.isNullOrUndefined(parent.servers)) {
            return;
        }
        let server : AaiServer = /* get */((m,k) => m[k]===undefined?null:m[k])(parent.servers, this._serverName);
        if(this.isNullOrUndefined(server)) {
            return;
        }
        let servers : any = parent.servers;
        /* remove */(map => { let deleted = servers[this._serverName];delete servers[this._serverName];return deleted;})(servers);
        if(/* size */Object.keys(servers).length === 0) {
            NodeCompat.setProperty(parent, Constants.PROP_SERVERS, null);
        }
        this._oldServer = Library.writeNode(server);
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[DeleteServerCommand_Aai20] Reverting.");
        if(this.isNullOrUndefined(this._oldServer)) {
            return;
        }
        let parent : Aai20Document = <Aai20Document>document;
        if(this.isNullOrUndefined(parent)) {
            return;
        }
        let server : AaiServer = parent.createServer$java_lang_String(this._serverName);
        Library.readNode(this._oldServer, server);
        let servers : any = parent.servers;
        if(this.isNullOrUndefined(servers)) {
            servers = <any>({});
            NodeCompat.setProperty(parent, Constants.PROP_SERVERS, servers);
        }
        /* put */(servers[this._serverName] = server);
    }
}
DeleteServerCommand_Aai20["__class"] = "io.apicurio.datamodels.cmd.commands.DeleteServerCommand_Aai20";
DeleteServerCommand_Aai20["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




